
export const allEntity = (meta) => meta.entities;
export const entity = (meta, entityType) => meta.entities[entityType];
export const propDisplay = (meta, entityType) => entity(meta, entityType).display;
export const propId = (meta, entityType) => entity(meta, entityType).identity;
export const endpointModify=(meta, entityType)=>entity(meta, entityType).endpoints.modify;
export const endpointCreate=(meta, entityType)=>entity(meta, entityType).endpoints.create;
export const endpointFindAll=(meta, entityType)=>entity(meta, entityType).endpoints.findAll;
export const endpointFindById=(meta, entityType)=>entity(meta, entityType).endpoints.findById;
export const allProps = (meta, entityType) => entity(meta, entityType).properties;
export const prop = (meta, entityType, propKey) => allProps(meta, entityType)[propKey];
export const isPropRef = (meta, entityType, propKey) => {

    const theProp=prop(meta, entityType, propKey);
    if (theProp) {
        return theProp.ref
    }
    return false;
};
export const entityCanModify = (meta, entityType) => endpointModify(meta, entityType)!==undefined;
export const entityCanCreate = (meta, entityType) => endpointCreate(meta, entityType)!==undefined;


// WEBPACK FOOTER //
// ./src/utils/metaUtil.js